import {useKeycloak} from '@react-keycloak/web';


/**
 * @returns {object} Authentication information
 */
export default function useAuthentication() {

    const {keycloak} = useKeycloak();

    return {
        isAuthenticated: keycloak.authenticated
    };
}
